import Utils from './utils.js';

const apiurl= window.apiurl; //"//cdnapi.rds.it/",
const version= "v2/";

const apiurlFanize= window.apiurlFanize;
const versionFanize= "api/v1/";

class Api {

      rawGet(call, data, callback, error) {
        // if (typeof callback === "function") {
        // } else {
        //   try {
        //     if (eval("typeof " + callback + " === 'function'")) {
        //       eval("callback = " + callback);
        //     } else {
        //       console.log("no function");
        //       callback = null;
        //     }
        //   } catch (e) {
        //     console.log("no function");
        //     callback = null;
        //   }
        // }

        // if (typeof error === "function") {
        // } else {
        //   try {
        //     if (eval("typeof " + error + " === 'function'")) {
        //       eval("error = " + error);
        //     } else {
        //       error = null;
        //     }
        //   } catch (e) {
        //     error = null;
        //   }
        // }

        var request = $.ajax({
          url: call,
          data: data,
          dataType: "json",
          xhrFields: { withCredentials: true },
          timeout: 60000,
          async: true,
          success: callback,
          error: function (jqXHR, textStatus, errorThrown) {
            if (typeof error === "function") {
              error(jqXHR, textStatus, errorThrown);
            }
          }
        });
        return request;
      }

      get(call, data, callback, error) {
        return this.rawGet(apiurl + version + call, data, callback, error);
      }

      post(call, data, callback, error) {
        // if (typeof callback === "function") {
        // } else {
        //   try {
        //     if (eval("typeof " + callback + " === 'function'")) {
        //       eval("callback = " + callback);
        //     } else {
        //       console.log("no function");
        //       callback = null;
        //     }
        //   } catch (e) {
        //     console.log("no function");
        //     callback = null;
        //   }
        // }

        // if (typeof error === "function") {
        // } else {
        //   try {
        //     if (eval("typeof " + error + " === 'function'")) {
        //       eval("error = " + error);
        //     } else {
        //       error = null;
        //     }
        //   } catch (e) {
        //     error = null;
        //   }
        // }

        var request = $.ajax({
          type: "POST",
          url: apiurl + version + call,
          data: data,
          dataType: "json",
          xhrFields: { withCredentials: true },
          timeout: 60000,
          async: true,
          success: callback,
          error: function (jqXHR, textStatus, errorThrown) {
            if (typeof error === "function") {
              error(jqXHR, textStatus, errorThrown);
            }
          }
        });
        return request;
      }

    postFormData(call,data,callback,error,timeout){
        // if(typeof callback === "function"){

        // }else{
        //     try{
        //         if ( eval("typeof "+callback+" === 'function'") ){
        //             eval("callback = "+callback);
        //         }else{
        //             console.log("no function");
        //             callback=null;
        //         }
        //     }catch(e){
        //         console.log("no function");
        //         callback=null;
        //     }
        // }

        // if(typeof error === "function"){

        // }else{
        //     try{
        //         if ( eval("typeof "+error+" === 'function'") ){
        //             eval("error = "+error);
        //         }else{
        //             error=null;
        //         }
        //     }catch(e){
        //         error=null;
        //     }
        // }

        if(!timeout){
            timeout = 60000;
        }

        var request = $.ajax({
            type: "POST",
            contentType: false,
            processData: false,
            url: apiurl + version + call,
            data: data,
            enctype: 'multipart/form-data',
            dataType: "json",
            xhrFields: { withCredentials:true },
            timeout: timeout,
            async: true,
            success: callback,
            error: function(jqXHR,textStatus,errorThrown){
                if (typeof error === "function"){
                    error(jqXHR,textStatus,errorThrown);
                }
            }
        });
        return request;
    }

  getOnFanize(call, data, callback, error) {

    var fanize_auth_token = Utils.getCookie("fanize_auth_token");

    var request = $.ajax({
      type: "GET",
      url: apiurlFanize + versionFanize + call,
      data: data,
      dataType: "json",
      "headers": {
        // "User-Agent": navigator.userAgent,
        "Authorization": "Bearer " + fanize_auth_token
      },
      // xhrFields: { withCredentials: true },
      timeout: 10000,
      async: true,
      success: callback,
      error: function (jqXHR, textStatus, errorThrown) {
        if (typeof error === "function") {
          error(jqXHR, textStatus, errorThrown);
        }
      }
    });
    return request;
  }

  postOnFanize(call, data, callback, error) {

      var fanize_auth_token = Utils.getCookie("fanize_auth_token");

      var request = $.ajax({
        type: "POST",
        url: apiurlFanize + versionFanize + call,
        data: data,
        dataType: "json",
        "headers": {
          "User-Agent": navigator.userAgent,
          "Authorization": "Bearer " + fanize_auth_token
        },
        // xhrFields: { withCredentials: false },
        timeout: 10000,
        async: true,
        success: callback,
        error: function (jqXHR, textStatus, errorThrown) {
          if (typeof error === "function") {
            error(jqXHR, textStatus, errorThrown);
          }
        }
      });
      return request;
  }

}

export default new Api();
